import { Box, Editable, EditablePreview, EditableTextarea, Text } from '@chakra-ui/react';
import { addNote, clearNote, saveNotes } from './utils';
import React from 'react';
import { MdOutlineQuickreply } from 'react-icons/md';
import { FaCheck } from 'react-icons/fa';
import { BsCheck } from 'react-icons/bs';

const ClearableNote = ({ note,noteOrder,notesUtils }) => {
  let date = note.date;
  let time = '';
  if (typeof note.date === 'object') {
    date = note.date.date;
    time = note.date.time;
  }
  const clear = note.cleared ? 'clear' : 'notClear';
  return(
    <Box>
    <Box display='flex' justify-content='flex-start'>
      <Box className={clear} >
        <button className="greenHover"
          onClick={() => notesUtils.clear(noteOrder)}
        >*</button>
      </Box>
      <Box className={clear}  marginLeft={'.5rem'} display={'flex'}>
        <Text
          className="date">{date}</Text> <Text className="time">{time}</Text>
      </Box>
    </Box>
    <Box marginBottom="1rem" marginLeft={'5%'} paddingLeft={'.5rem'}>
      <Box className={clear} marginLeft={'.5rem'}>
        <Text className={clear} >{note.note}</Text>
      </Box>
      <Box className="editNoteButtonWrapper">
        <Text className="editNoteButton" onClick={(e) => notesUtils.addReply(e, noteOrder)}><MdOutlineQuickreply /></Text>
      </Box>
    </Box>
</Box>
  );

}
export default ClearableNote;